import { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { adjusters } from '@/data/MoAdjusters';
import { Pagination } from 'antd';

const Adjusters = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);

  const keyword = params.get('keyword')?.trim() || '';
  const filter = params.get('filter') || 'all';
  const initialPage = parseInt(params.get('page') || '1', 10);

  const [page, setPage] = useState(initialPage);
  const pageSize = 5;

  // 쿼리 파라미터에 따라 URL 업데이트
  useEffect(() => {
    navigate(`?filter=${filter}&keyword=${keyword}&page=${page}`, { replace: true });
  }, [page, keyword, filter]);

  // 필터링
  const filteredAdjusters = useMemo(() => {
    if (!keyword) return adjusters;

    if (filter === 'name') {
      return adjusters.filter((a) => a.name.includes(keyword));
    } else if (filter === 'detail') {
      return adjusters.filter((a) => a.detail.includes(keyword));
    } else {
      return adjusters.filter((a) => a.name.includes(keyword) || a.detail.includes(keyword));
    }
  }, [keyword, filter]);

  // 페이지 나누기
  const totalPages = Math.ceil(filteredAdjusters.length / pageSize);
  const totalItems = filteredAdjusters.length;
  const pagedAdjusters = filteredAdjusters.slice((page - 1) * pageSize, page * pageSize);

  return (
    <>
      <Wrapper>
        {pagedAdjusters.map((adjuster) => (
          <Card key={adjuster.id}>
            <ImageBox onClick={() => navigate(`/intro/adjusters/${adjuster.id}`)}>
              <StyledImage src={adjuster.image} alt={adjuster.name} />
            </ImageBox>
            <InfoBox>
              <Label>{adjuster.label}</Label>
              <NameRow>
                <Name>{adjuster.name}</Name>
                <RegionTag>{adjuster.region}</RegionTag>
              </NameRow>
              <Detail>{adjuster.detail}</Detail>
              <ViewButton onClick={() => navigate(`/intro/adjusters/${adjuster.id}`)}>
                <ViewButtonInner>자세히 보기</ViewButtonInner>
              </ViewButton>
            </InfoBox>
          </Card>
        ))}
      </Wrapper>

      {totalPages > 1 && (
        <Pagination
          current={page}
          pageSize={pageSize}
          total={totalItems}
          onChange={(newPage) => setPage(newPage)}
          showSizeChanger={false} // 페이지 크기 선택 비활성화
        />
      )}
    </>
  );
};

export default Adjusters;

// ✅ 스타일들
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
`;

const ImageBox = styled.div`
  height: 234px;
  border-radius: 8px;
  background-color: #f3f3f3;
  overflow: hidden;
`;

const StyledImage = styled.img`
  object-fit: cover;
  cursor: pointer;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Label = styled.div`
  color: #6f6f6f;
  font-size: 16px;
  font-weight: 400;
  text-align: start;
  cursor: text;
`;

const NameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Name = styled.div`
  color: #252525;
  font-size: 26px;
  font-weight: 700;
  cursor: text;
`;

const RegionTag = styled.div`
  padding: 0px 8px;
  border-radius: 99px;
  background: #f3f3f3;
  color: #000c24;
  font-size: 14px;
`;

const Detail = styled.div`
  color: #999;
  font-size: 14px;
  line-height: 150%;
  text-align: start;
  cursor: text;
`;

const ViewButton = styled.button`
  max-width: 120px;
  height: 40px;
  border-radius: 8px;
  background: #f0f3fe;
  border: none;
  text-align: start;
  cursor: pointer;

  &:hover div {
    color: #4c84e3;
  }
`;

const ViewButtonInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
